import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchPermissions } from '@/api/access/accessApi';
import type { Permission } from '@/api/access/accessApi.types';
import { PERMISSIONS_QUERY_KEY } from '@/constants/queryKeys';

export function usePermissionsQuery(): UseQueryResult<Permission[], Error> {
  return useQuery({
    queryKey: PERMISSIONS_QUERY_KEY,
    queryFn: fetchPermissions,
    staleTime: Infinity,
  });
}
